import React from 'react'
import { colors, useContainerWidth, H1 } from '@fs/zion-ui'
import { Trans } from 'react-i18next/icu.macro'
import { css } from '@emotion/core'

// eslint-disable-next-line no-unused-vars
const peopleEverywhere = css`
  color: ${colors.yellow50};
`
// eslint-disable-next-line no-unused-vars
const connect = css`
  color: ${colors.green50};
`
// eslint-disable-next-line no-unused-vars
const family = css`
  color: ${colors.blue50};
`
const pageHeaderSmall = css`
  margin: 100px auto;
  padding: 0 12px;
`
const pageHeaderMedium = css`
  margin: 100px auto;
  max-width: 600px;
  padding: 0 24px;
`
const pageHeaderLarge = css`
  margin: 100px auto;
  max-width: 720px;
`

export default function AboutPageHeader() {
  const atWidth = useContainerWidth()

  return (
    <div
      css={atWidth({
        default: pageHeaderSmall,
        md: pageHeaderMedium,
        xxl: pageHeaderLarge,
      })}
    >
      <H1
        size={atWidth({
          default: 'H4',
          xxl: 'H3',
        })}
        centered
      >
        <Trans
          i18nKey="about.purpose-statement.heading"
          defaults="We inspire <span css={peopleEverywhere}>people everywhere</span> to <span css={connect}>connect</span> with their <span css={family}>family</span>—across generations."
          values={{ peopleEverywhere, connect, family }}
        />
      </H1>
    </div>
  )
}
